import { createSlice } from '@reduxjs/toolkit';

/**
 * This tracks the state of the feed items. Currently it only tracks whether or not the feed
 * item has been expanded. This persists until the browser refreshes.
 */

export interface CommentDeletePayload {
	id: string;
	isLoading: boolean;
	isSuccess: boolean;
	isError: boolean;
}
export interface CommentDeleteState {
	currentComment: CommentDeletePayload;
}

export const CommentViewSlice = createSlice({
	name: 'commentDeleteState',
	initialState: {} as CommentDeleteState,
	reducers: {
		setCommentView: (state, { payload }: { payload: CommentDeletePayload }) => {
			state.currentComment = {
				id: payload.id,
				isError: payload.isError,
				isLoading: payload.isLoading,
				isSuccess: payload.isSuccess
			};
		}
	}
});

// Action creators are generated for each case reducer function
export const { setCommentView } = CommentViewSlice.actions;

export default CommentViewSlice.reducer;
